/** @format */

import React, { useState, useEffect } from 'react';
import FormInput from '../form-input/form-input.component';
import Modal from '../modal/modal.component';
import { connect } from 'react-redux';
import { pink } from '@mui/material/colors';
import { createStructuredSelector } from 'reselect';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CustomButton from '../custom-button/custom-button.component';
import {
  selectTermDepartment,
  selectTermPosition,
  selectTermNavitaire,
  selectTermNoc,
  selectTermEmail,
  selectForwardingEmail,
  selectTermLocation,
  selectTermUber,
  selectTermLyft,
  selectSuspendAzure,
} from '../../redux/termination/termination.selector';

import {
  setTermEmail,
  setForwardingEmail,
  setTermLocation,
  setSuspendAzure,
} from '../../redux/termination/termination.actions';

import { Box, Container } from '@mui/material';
import { socket } from '../../utils/socketIo';
import './termination-form.styles.css';

const NewHireForm = ({
  currTermDepartment,
  currTermPosition,
  currTermEmail,
  noc,
  navitaire,
  uber,
  lyft,
  location,
  setCurrTermEmail,
  forwardingEmail,
  setCurrForwardingEmail,
  setTermLocation,
  setSuspendAzure,
  suspendAzure,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const [accCreationMessages, setMessage] = useState([]);

  const closeModal = () => {
    setIsOpen(false);
    // * Reset update messages array
    // setMessage([]);
  };
  useEffect(() => {
    socket.on('GoogleAccountTerminationUpdate', (data) => {
      setMessage((oldArray) => [...oldArray, data]);
      setIsOpen(true);
    });

    socket.on('AzureAccountTerminationUpdate', (data) => {
      setMessage((oldArray) => [...oldArray, data]);
      setIsOpen(true);
    });

    socket.on('NocAccountTerminationUpdate', (data) => {
      setMessage((oldArray) => [...oldArray, data]);
      setIsOpen(true);
    });
    socket.on('NavitaireAccountTerminationUpdate', (data) => {
      setMessage((oldArray) => [...oldArray, data]);
      setIsOpen(true);
    });

    setSuspendAzure(false);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    socket.emit('AzureAuthCodeTerm', {
      department: currTermDepartment,
      position: currTermPosition,
      noc: noc,
      navitaire: navitaire,
      uber: uber,
      lyft: lyft,
      email: currTermEmail,
      forwardingEmail: forwardingEmail,
      locationCode: location,
      suspendAzure: suspendAzure,
    });
  };

  const handleChange = (event) => {
    const { value, name, checked } = event.target;

    if (name === 'email') {
      setCurrTermEmail(value);
    } else if (name === 'location') {
      setTermLocation(value);
    } else if (name === 'azure') {
      setSuspendAzure(checked);
    } else {
      setCurrForwardingEmail(value);
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <Container
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <FormInput
            name="email"
            type="email"
            handleChange={handleChange}
            value={currTermEmail}
            label="Primary Email"
            className="nh_input mhFirst"
            id="nhFirst"
            style={{ marginRight: '20px' }}
            required
          />

          <FormInput
            name="forwardingEmail"
            type="email"
            handleChange={handleChange}
            value={forwardingEmail}
            label="Forwarding Email (optional)"
            className="nh_input"
            id="nhFirst"
            style={{ marginRight: '20px' }}
          />

          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="azure"
                  sx={{
                    color: pink[800],
                    '&.Mui-checked': {
                      color: pink[600],
                    },
                    mx: 1,
                  }}
                  value={suspendAzure}
                  onChange={handleChange}
                  // default
                />
              }
              label="Suspend Azure Account"
            />
          </FormGroup>
          {navitaire && navitaire.account && (
            <FormInput
              name="location"
              type="text"
              handleChange={handleChange}
              value={location}
              label="Location Code"
              id="nhLoc"
              className="nh_input"
              required
            />
          )}
        </Container>

        <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
          <CustomButton
            type="submit"
            name="terminator"
            style={{ margin: '20px' }}
          >
            Deprovision Accounts
          </CustomButton>
        </Box>
      </form>

      {isOpen && (
        <Modal
          modalOpen={isOpen}
          handleClose={closeModal}
          text={`Account Termination Updates`}
          type="dropIn"
          data={accCreationMessages}
          variant={'accCreationStatus'}
        />
      )}
    </Box>
  );
};

const mapStateToProps = createStructuredSelector({
  currTermDepartment: selectTermDepartment,
  currTermPosition: selectTermPosition,
  noc: selectTermNoc,
  navitaire: selectTermNavitaire,
  uber: selectTermUber,
  lyft: selectTermLyft,
  currTermEmail: selectTermEmail,
  forwardingEmail: selectForwardingEmail,
  location: selectTermLocation,
  suspendAzure: selectSuspendAzure,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrTermEmail: (email) => dispatch(setTermEmail(email)),
  setCurrForwardingEmail: (email) => dispatch(setForwardingEmail(email)),
  setTermLocation: (location) => dispatch(setTermLocation(location)),
  setSuspendAzure: (bool) => dispatch(setSuspendAzure(bool)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewHireForm);
